export default __webpack_public_path__ + "static/media/Image-1.32a30630.png";